import { ParsedQuery } from 'query-string'

import { NDSTag } from './sendPageViewLog'

export const IGNORE_PATHNAMES = ['/year-end/2022', '/home']

export const isIgnorePath = (pathname: string, query?: ParsedQuery) => {
  if (IGNORE_PATHNAMES.includes(pathname)) return true

  // https://oss.navercorp.com/place/local/issues/16087#issuecomment-12386194
  if (pathname === '/review/complete/[reviewGroupId]' && query?.isFirstEntry === 'true') return true

  return false
}

// NOTE: key route로 변경
export const NDS_TAGS_MAP: { [pathname: string]: readonly NDSTag[] } = {
  '/following-feed': [NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY],
  '/[objectId]/followers': [NDSTag.DISCOVERY_SELF, NDSTag.DISCOVERY, NDSTag.SPEND_SELF],
  '/[objectId]/following': [NDSTag.DISCOVERY_SELF, NDSTag.DISCOVERY, NDSTag.SPEND_SELF],
  '/place': [NDSTag.SPEND_SELF],
  '/timeline': [NDSTag.ADVERTISE, NDSTag.SPEND_SELF],
  '/timeline/canceled': [NDSTag.SPEND_SELF],
  '/review': [NDSTag.ADVERTISE, NDSTag.SPEND_SELF],
  '/[objectId]/review': [NDSTag.ADVERTISE, NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY],
  '/checkin': [NDSTag.CREATE_VISIT],
  '/checkin/payment': [NDSTag.CREATE_VISIT],
  '/checkin/receipt': [NDSTag.CREATE_VISIT],
  '/': [NDSTag.ADVERTISE, NDSTag.DISCOVERY_SELF, NDSTag.DISCOVERY, NDSTag.SPEND_SELF],
  '/home': [NDSTag.ADVERTISE, NDSTag.DISCOVERY_SELF, NDSTag.DISCOVERY, NDSTag.SPEND_SELF],
  '/map/[objectId]': [NDSTag.SPEND_SELF],
  '/place/detailList/[shareId]': [NDSTag.SPEND_SELF],
  '/maps/place/detailList/[shareId]': [NDSTag.SPEND_SELF],
  '/mission': [NDSTag.CREATE_REVIEW],
  '/payments': [NDSTag.CREATE_REVIEW],
  '/reactions': [NDSTag.DISCOVERY_SELF, NDSTag.DISCOVERY, NDSTag.SPEND_SELF],
  '/receipt': [NDSTag.CREATE_VISIT],
  '/review/[reviewGroupId]/paymentInfo': [NDSTag.BUSINESS],
  '/review/complete/[reviewGroupId]': [NDSTag.CREATE_REVIEW, NDSTag.DISCOVERY],
  '/review/edit/[reviewGroupId]': [NDSTag.CREATE_REVIEW],
  '/review/new/visit/[visitId]': [NDSTag.CREATE_REVIEW],
  '/setting/tags': [NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY],
  '/theme/[themelistId]/edit': [NDSTag.CREATE_REVIEW],
  '/theme/new': [NDSTag.CREATE_REVIEW],
  '/visit/[visitId]': [NDSTag.SPEND_SELF, NDSTag.ADVERTISE],
  '/visit/new': [NDSTag.CREATE_VISIT],
} as const

export const NDS_TAGS_WITH_MY_PAGE_MAP: {
  [pathname: string]: { isMyPage: readonly NDSTag[]; isOthersPage: readonly NDSTag[] }
} = {
  '/[objectId]/reviewfeed': {
    isMyPage: [NDSTag.SPEND_SELF, NDSTag.ADVERTISE, NDSTag.REVIEWFEED_SELF],
    isOthersPage: [NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY, NDSTag.ADVERTISE, NDSTag.REVIEWFEED_OTHER],
  },
  '/review/[reviewGroupId]': {
    isMyPage: [NDSTag.ADVERTISE, NDSTag.SPEND_SELF, NDSTag.REVIEWEND_SELF],
    isOthersPage: [NDSTag.ADVERTISE, NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY, NDSTag.REVIEWEND_OTHER],
  },
  '/theme/[themelistId]': {
    isMyPage: [NDSTag.SPEND_SELF, NDSTag.THEME_SELF],
    isOthersPage: [NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY, NDSTag.THEME_OTHER],
  },
  '/theme/[themelistId]/map': {
    isMyPage: [NDSTag.SPEND_SELF, NDSTag.THEMEMAP_SELF],
    isOthersPage: [NDSTag.DISCOVERY_OTHER, NDSTag.DISCOVERY, NDSTag.THEMEMAP_OTHER],
  },
} as const
